<template>
	<div>
		<!-- Main -->
		<nav class="uk-navbar-container uk-margin-small-bottom" uk-navbar>
			<div class="uk-navbar-left">
				<span class="uk-navbar-item uk-logo">シフトインポート (CSV)</span>
			</div>
			<div class="uk-navbar-right">
				<template v-if="current_staff != null">
					<div class="navbar-item">
						<p class="uk-text-small uk-margin-right uk-margin-remove-bottom">こんにちは、{{ current_staff.display_name }}さん</p>
					</div>
				</template>
				<div class="navbar-item">
					<button class="uk-button uk-text-small uk-button-small uk-button-default" @click="clickLogoutButton">ログアウト</button>
				</div>
			</div>
		</nav>
		<div class="uk-container uk-container-expand uk-margin-medium uk-margin-remove-left uk-margin-remove-right">
			<div class="uk-align-right">
				<router-link class="uk-button uk-button-default" to="/shop">戻る</router-link>
			</div>
		</div>
		<!--/ Main -->
		<div class="uk-container uk-container-expand uk-margin-large-bottom">
			<h1 class="uk-heading-divide ruk-padding uk-text-center">インポート</h1>
			<div class="uk-margin uk-padding uk-text-center">
				<input id="file" type="file">
			</div>
			<div class="uk-margin uk-padding uk-text-center">
				<p>指定されたファイルをインポートします。よろしいですか。</p>
			</div>
			<div class="uk-margin uk-padding uk-text-center">
				<button class="uk-button uk-button-default" @click="upload">インポート</button>
			</div>
			<div class="uk-margin uk-padding uk-text-center">
				<p>インポートには時間がかかります。</p>
				<p>ステータスが異常になった場合は、インポートをやり直してください。</p>
				<p>最終更新日時: {{ last_updated | moment }}</p>
			</div>
		</div>
		<div id="progress-import" uk-modal>
			<div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical uk-text-center" :class="visibleStateLoading"><i class="fas fa-spinner fa-spin"></i> インポート中...</div>
		</div>
	</div>
</template>

<script>

	import CsvImport from '@/api/CsvImport'
	import StaffAuth from '@/api/StaffAuth'
	import Role from '@/api/Role'
	import Tag from '@/api/Tag'
	import MainOfficeAuth from '@/api/MainOfficeAuth'
	import CallCenterAuth from '@/api/CallCenterAuth'
	import BranchOfficeAuth from '@/api/BranchOfficeAuth'

	export default {
		name: 'ShopTodoListDownloadPage',
		comments: [],
		data () {
			return {
				last_updated: null,
				current_staff: null,
				is_click: false
			}
		},
		filters: {
			moment: function (date) {
				return moment(date).format('YYYY/MM/DD HH:mm')
			}
		},
		methods: {
			clickLogoutButton () {
				let self = this

				StaffAuth.logout().then(function (response) {
					// CallCenterAuth.logout().then(function (response) {
						// BranchOfficeAuth.logout().then(function (responase) {
							// MainOfficeAuth.logout().then(function (response) {
								self.$router.push('/')
								location.reload()
							// })
						// })
					// })
				})
			},
			upload () {
				let self = this
				StaffAuth.current().then(function (response) {
					let params = new FormData()
					params.append('file', $('#file')[0].files[0])
					params.append('shop_id', response.data.data.shop_id)

					UIkit.modal('#progress-import', {container: '#app div', bgClose: false}).show()
					self.is_click = true
					CsvImport.importStaffWorkScheduleForShop(params).then(function (response) {
						let data = response.data.data

						if (response.data.message == 'FAIL') {
							if (data.count > 0) {
								alert(data.error_message + '(' + data.count + '件目)')
							} else {
								alert(data.error_message)
							}
						} else {
							if (data.staff_not_found_count > 0) {
								alert('インポートが完了しました(' + data.staff_not_found_count + '件の存在しない社員番号をスキップ)')
							} else {
								alert('インポートが完了しました')
							}
							self.last_updated = data.time
						}
						self.is_click = false
						UIkit.modal('#progress-import').hide()
					}, function () {
						alert('インポート処理でエラーが発生しました。')
						UIkit.modal('#progress-import').hide()
						self.is_click = false
					})
				})
			}
		},
		created () {
		},
		beforeMount () {
		},
		mounted () {
			let self = this
			Role.show().then(function (response) { // 権限取得
				let data = response.data

				if (data.data.is_admin_staff != true) { // 管理者スタッフではない場合
					self.$router.push('/')
				}
			})

			StaffAuth.current().then(function (response) {
				self.current_staff = response.data.data

				let params = new URLSearchParams()
				params.append('key', 'last_import_work_schedule_time[' + self.current_staff.shop_id + ']')

				Tag.one(params).then(function (response) {
					self.last_updated = moment(response.data.data.value).format('YYYY-MM-DD HH:mm:ss')
				})
			})
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/page/ShopImportWorkSchedulePage.vue